import React from 'react';
import ComingSoon from 'react-coming-soon';

const IndexPage = () => (
<ComingSoon title="Authenticating data" subtitle="Building content and dependencies" bgColor="#bbb8c3" textColor="#ffffff" illustration="react" />
);

export default IndexPage;
